<div class="mb-3">
  <div>

    <h1 class="pb-2 border-bottom fw-light" data-testid="sale-order-list-heading" i18n>Verkäufe</h1>

    <div class="mt-3">
      <app-order-search (searchCriteria)="search($event)"></app-order-search>
    </div>

    <kendo-grid
      [data]="list.gridData"
      [pageable]="true"
      [skip]="list.state.skip"
      [pageSize]="list.state.pageSize"
      [sortable]="true"
      [sort]="list.state.sort"
      (pageChange)="list.onPageChange($event)"
      (sortChange)="list.onSortChange($event)"
      [reorderable]="true"
      [resizable]="true">
      <ng-template kendoGridNoRecordsTemplate>
        <app-grid-no-records [loading]="list.loading" loadingText="Aufträge werden geladen…" i18n-loadingText></app-grid-no-records>
      </ng-template>
      <ng-template kendoGridToolbarTemplate>
        <button kendoGridPDFCommand icon="file-pdf" i18n>PDF-Export</button>
      </ng-template>
      @if (isRetailer) {
        <kendo-grid-column field="buyerCustomerFullName" [sortable]="false" i18n-title title="Käufer" [width]="200"></kendo-grid-column>
      }
      <kendo-grid-column field="orderDateTime" format="{0:g}" i18n-title title="Datum / Uhrzeit" [width]="150"></kendo-grid-column>
      <kendo-grid-column field="orderPositions.length" [sortable]="false" i18n-title title="Anzahl" [width]="80"></kendo-grid-column>
      <kendo-grid-column field="grossPrice" [sortable]="false" i18n-title title="VK" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.grossPrice | currency: dataItem.currency }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="discount" [sortable]="false" i18n-title title="Rabatt" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.discount | currency: dataItem.currency }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="discountedGrossPrice" [sortable]="false" i18n-title title="EK" [width]="80">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ dataItem.discountedGrossPrice | currency: dataItem.currency }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="userName" [sortable]="false" i18n-title title="Benutzer" [width]="150"></kendo-grid-column>
      <kendo-grid-command-column i18n-title title="Details" [width]="70">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="d-flex justify-content-center gap-2">
            <button type="button" class="btn btn-sm btn-outline-secondary" title="Details" aria-label="Details" i18n-title i18n-aria-label (click)="onDetails(dataItem.id)" >
              <i><fa-icon [icon]="faInfoCircle"></fa-icon></i>
            </button>
          </div>
        </ng-template>
      </kendo-grid-command-column>
      <kendo-grid-pdf appGridPdf fileName="Verkäufe.pdf" [allPages]="true" paperSize="A4" [repeatHeaders]="true" [scale]="0.75">
        <kendo-grid-pdf-margin top="2cm" left="1cm" right="1cm" bottom="2cm"></kendo-grid-pdf-margin>
        <ng-template kendoGridPDFTemplate let-pageNum="pageNum" let-totalPages="totalPages">
          <app-pdf-page title="Verkäufe" i18n-title [pageNum]="pageNum" [totalPages]="totalPages"></app-pdf-page>
        </ng-template>
      </kendo-grid-pdf>
    </kendo-grid>
  </div>
</div>